import { gql } from 'graphql.macro';

export const updateInternalDeliveryDateTemplate = gql`
    mutation updateInternalDeliveryDate($orderId: MongoDbObjectId!, $internalDeliveryDate: Date) {
        updateInternalDeliveryDate(orderId: $orderId, internalDeliveryDate: $internalDeliveryDate) {
            _id
            deliveryDetails {
                internalDeliveryDate
            }
        }
    }
`;

export const updateExternalDeliveryDateTemplate = gql`
    mutation updateExternalDeliveryDate($orderId: MongoDbObjectId!, $externalDeliveryDate: Date) {
        updateExternalDeliveryDate(orderId: $orderId, externalDeliveryDate: $externalDeliveryDate) {
            _id
            deliveryDetails {
                externalDeliveryDate
            }
        }
    }
`;

export const removeFromScheduleTemplate = gql`
    mutation removeFromSchedule($orderId: MongoDbObjectId!) {
        removeFromSchedule(orderId: $orderId) {
            _id
            deliveryDetails {
                externalDeliveryDate
            }
        }
    }
`;
